import { Suspense, useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import styles from './Navigation.module.css';
import { useGetOpenBankingStatus } from '../../dataHelpers/OnlineAccounts/useGetOpenBankingStatus';
import { ErrorBoundary } from '../../errorBoundary/ErrorBoundary';
import { BankSelectionModal } from '../modals/BankSelectionModal/BankSelectionModal';
import { useGetLinkedAccounts } from '../modals/BankSelectionModal/useGetLinkedAccounts';
import { BankIconWithDot } from '../ui/OpenBankingStatusIndicator/BankIconWithDot';

type OpenBankingStatus = 'disconnected' | 'expired' | 'expiring' | 'connected';
type IconStatus = 'active' | 'expiring' | 'expired';

const ICON_STATUS: Record<OpenBankingStatus, IconStatus> = {
    disconnected: 'expired',
    expired: 'expired',
    expiring: 'expiring',
    connected: 'active'
};

export const OpenBankingNavAction = () => (
    <ErrorBoundary fallback={() => null}>
        <Suspense fallback={null}>
            <OpenBankingNavActionContent />
        </Suspense>
    </ErrorBoundary>
);

const OpenBankingNavActionContent = () => {
    const status = useGetOpenBankingStatus();
    const linkedAccounts = useGetLinkedAccounts();
    const iconStatus = ICON_STATUS[status];
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        tracking.ampli.track({
            event_type: 'OB Status Widget Displayed',
            event_properties: { status, source: 'nav_icon' }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleIconClick = () => {
        tracking.ampli.track({
            event_type: 'OB Status Widget Action Clicked',
            event_properties: { status, source: 'nav_icon' }
        });
        setIsModalOpen(true);
    };

    return (
        <>
            <button
                type="button"
                onClick={handleIconClick}
                aria-label={`Open banking status: ${iconStatus}`}
                className={`${styles.rightAction} relative inline-flex items-end border-none bg-transparent p-0`}
            >
                <span className="size-[20px]">
                    <BankIconWithDot status={iconStatus} />
                </span>
            </button>
            <BankSelectionModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                linkedAccounts={linkedAccounts}
            />
        </>
    );
};
